import { User } from 'Types/User';
import axios, { throwAxiosError } from './request';

const endpoint = `/users/`;

export const updateUser = async (
  userId: string,
  u: User
): Promise<User | null> => {
  try {
    const { data } = await axios.put(`${endpoint}${userId}/`, u);
    if (data) {
      return data as User;
    }
  } catch (error) {
    throwAxiosError(error);
  }
  return null;
};

export default {};
